export default {
  /**
   * Lỗi validate
   */
  Arise: 0,
};
